import { useCallback } from "react"
import { fetchPharmacies } from "../handlers/pharmacyHandlers"

/**
 * Hook para acceder a la lista de farmacias
 * @returns {Object} - Objeto con funciones para obtener farmacias
 */
export const usePharmacyService = () => {
    const getPharmacies = useCallback(async () => {
        const response = await fetchPharmacies()

        if (response && response.data) {
            return response.data.map((pharmacy) => ({
                name: pharmacy.name,
                label: pharmacy.name_editable,
            }))
        }

        return []
    }, [])

    return {
        getPharmacies,
    }
}

